import { RuleNestedArray } from '..'
import { msg } from '../messages'

export const ONLY_LETTERS = /^([a-zA-ZáéíóúÁÉÍÓÚçÇâêôÂÊÔõãÕÃäöüÄÖÜàÀ '\s])+$/

export const nome: RuleNestedArray = [
  (inputValue: string): string => {
    if (!inputValue) {
      return null
    }

    if (!ONLY_LETTERS.test(inputValue)) {
      return msg('nomeInvalido', inputValue)
    }

    // Deve possuir ao menos 3 caracteres
    if (inputValue.length < 3) {
      return msg('minLength', inputValue, 3)
    }

    const nomes: string[] = inputValue && inputValue.split(' ')
    if (nomes.length < 2) {
      return msg('nome', inputValue)
    }

    if (nomes[0].length === 1 && nomes[1].length === 1) {
      return msg('nomeOneLetter', inputValue)
    }

    if (nomes.length === 2) {
      if (nomes[0].length === 2 && nomes[1].length === 2) {
        return msg('nomeTwoLetters', inputValue)
      }
    }

    return null
  },
]
